import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/app/szolgaltato/regisztracio/page.module.css");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/_dot.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/loader.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/common/buttons/button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/link_with_params/link_with_params.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/provider_registration/provider_registration.js");
;
import(/* webpackMode: "eager", webpackExports: ["clearBackendTokenFromSecureStorage"] */ "/opt/project/src/utils/mobile-secure-token.js");
